import { Component, OnInit, Input } from '@angular/core';
import *  as $ from 'jquery';

import { ChartType, ChartOptions } from 'chart.js';
import { MultiDataSet, Label, PluginServiceGlobalRegistrationAndOptions } from 'ng2-charts';

import { WizardService } from 'app/main/wizard-n35/services/wizard.service';
import * as backInter from 'app/auth/auth-data.model';

import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { lang_resultados35 } from 'app/idiomas/i18n/resultados35/resultados35.lang';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-generales',
  templateUrl: './generales.component.html',
  styleUrls: ['./generales.component.scss']
})
export class GeneralesComponent implements OnInit {
  @Input() productoID: any;
  @Input() centroDeTrabajoId:any;
  nombreEmpresa:any;
  ct:String;
  domicilio:String;
  actividadP:String;
  objetivo:string;
  principalesActividades:string;

  fechaA:string;
  totalColaboradores:number;
  totalEncuestados:number;
  noAceptaronEncuesta:number;
  colaboradoresSujetosAT:number;

  porcentajeParticipacion:number;
  doughnutChartOptions: ChartOptions;
  doughnutChartLabels: Label[];
  doughnutChartData: MultiDataSet;
  doughnutChartType: ChartType;
  doughnutChartColors:any;
  doughnutChartPlugins:PluginServiceGlobalRegistrationAndOptions[] ;

  personasMujeres:number;
  porcentajeMujeres:number;
  mujeresChartOptions: ChartOptions;
  mujeresChartLabels: Label[];
  mujeresChartData: MultiDataSet;
  mujeresChartType: ChartType;
  mujeresChartColors:any;
  mujeresChartPlugins:PluginServiceGlobalRegistrationAndOptions[];

  personasHombres:number;
  porcentajeHombres:number;
  hombresChartOptions: ChartOptions;
  hombresChartLabels: Label[];
  hombresChartData: MultiDataSet;
  hombresChartType: ChartType;
  hombresChartColors:any;
  hombresChartPlugins:PluginServiceGlobalRegistrationAndOptions[];

  ventana_ancho = $(window).width();
  fuente:number=23;
  fuenteGraficasSexo:number=20;

  cargando:boolean=true;
  urlCTIndividual:any;


  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private wizardService: WizardService,
    private translateSrv: TranslateService
  ) {
    lang_resultados35.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    this.getGeneralesCT();
    // this.getDatosEmpresa();
    console.log(this.productoID);
    console.log(this.centroDeTrabajoId);
  }

  // getDatosEmpresa(){
  //   this.wizardService.getDatosEmpresa().subscribe( (datos: backInter.infoEmpresa) => {
  //     // console.log(datos);
  //     this.nombreEmpresa=datos.data.nombreEmpresa;
  //   });
  // }

  getGeneralesCT(){
    let data={
      productoId: this.productoID,
      id_CT:this.centroDeTrabajoId
    }
    if(localStorage.getItem('empresaPadre')){
      this.urlCTIndividual=localStorage.getItem('empresaPadre');
    }
    else{
      this.urlCTIndividual="";
    }
    this.wizardService.getGeneralesCT(this.urlCTIndividual, data).subscribe( (datos: backInter.GeneralesCentrosDeTrabajo) => {
      console.log(datos);
      this.nombreEmpresa=datos.empresa;
      this.ct=datos.centroTrabajo;
      this.domicilio=datos.domicilio;
      this.actividadP=datos.actividadPrincipal;
      this.fechaA=datos.fechaAplicacion.substring(0,10);;
      this.totalColaboradores=datos.totalColaboradores;
      this.objetivo=datos.actividades;
      this.principalesActividades=datos.objetivo;
      this.totalEncuestados=datos.totalEncuestados;
      this.noAceptaronEncuesta=datos.noAcept;
      this.colaboradoresSujetosAT=datos.ayuda;

      this.porcentajeParticipacion=Math.round((datos.totalEncuestados/datos.totalColaboradores)*100);
      this.graficoDona(this.porcentajeParticipacion);

      this.personasMujeres=datos.mujeres;
      this.porcentajeMujeres=Math.round((datos.mujeres/datos.totalColaboradores)*100);
      this.graficoMujeres(this.personasMujeres, this.porcentajeMujeres);

      this.personasHombres=datos.hombres;
      this.porcentajeHombres=Math.round((datos.hombres/datos.totalColaboradores)*100);
      this.graficoHombres(this.personasHombres, this.porcentajeHombres);

      this.cargando=false;
    });
  }

  graficoDona(numero:any){
    let label1 = 'SECCIONES.GENERALES.PORCENTAJE_PARTICIPACION';
    let label2 = 'SECCIONES.GENERALES.PORCENTAJE_NOPARTICIPACION';
    this.translateSrv.get(label1).subscribe((res: string) => { label1 = res; });
    this.translateSrv.get(label2).subscribe((res: string) => { label2 = res; });
    // Doughnut
    this.detectScreen();
    this.doughnutChartOptions= {
     responsive: true,
     legend: {
       position: 'bottom',
       fullWidth:true,
       labels: {
                fontSize: this.fuente,
                fontColor: 'rgb(0, 0, 0)',
                fontStyle: 'bold',
            },
        onClick: function (e) {
        e.stopPropagation();
      },
     },
   };
    this.doughnutChartLabels= [label1,label2];
    this.doughnutChartData= [
      [numero, (100-numero)],
    ];
    this.doughnutChartType= 'doughnut';

    this.doughnutChartColors = [
     {
       backgroundColor: ['rgba(5, 40, 115)', 'rgba(255, 255, 255 )'],
       borderColor:['rgba(5, 40, 115)', 'rgba(5, 40, 115)'],
     },
   ];

   this.doughnutChartPlugins= [{
      beforeDraw(chart) {
        const ctx = chart.ctx;
        const txt = 'Center Text';

        //Get options from the center object in options
        const sidePadding = 60;
        const sidePaddingCalculated = (sidePadding / 100) * (chart.options.aspectRatio * 2)

        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        const centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);
        const centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 2);

        //Get the width of the string and also the width of the element minus 10 to give it 5px side padding
        const stringWidth = ctx.measureText(txt).width;
        const elementWidth = (chart.options.aspectRatio * 2) - sidePaddingCalculated;

        // Find out how much the font can grow in width.
        const widthRatio = elementWidth / stringWidth;
        const newFontSize = Math.floor(30 * widthRatio);
        const elementHeight = (chart.options.aspectRatio * 2);

        // Pick a new font size so it will not be larger than the height of label.
        const fontSizeToUse = Math.min(newFontSize, elementHeight);

        ctx.font = fontSizeToUse + 'px Arial';
        ctx.fillStyle = 'rgba(5, 40, 115)';

        // Draw text in center
        ctx.fillText(numero+'%', centerX, centerY);
      }
    }];
  }

  graficoMujeres(numero:any, porcentaje:any){
    let label1 = 'SECCIONES.GENERALES.PERSONAS';
    this.translateSrv.get(label1).subscribe((res: string) => { label1 = res; });
    // Doughnut
    this.detectScreen();
    this.mujeresChartOptions= {
     responsive: true,
     tooltips: {enabled: false},
     hover: {mode: null},
     legend: {
       position: 'bottom',
       fullWidth:true,
       labels: {
                fontSize: this.fuenteGraficasSexo,
                fontColor: 'rgb(0, 0, 0)',
                fontStyle: 'bold',
            },
        onClick: function (e) {
        e.stopPropagation();
      },
     },
   };
    this.mujeresChartLabels= [(numero+label1)];
    this.mujeresChartData= [
      [porcentaje, (100-porcentaje)],
    ];
    this.mujeresChartType= 'doughnut';

    this.mujeresChartColors = [
     {
       backgroundColor: ['rgba(43, 218, 228 )', 'rgba(255, 255, 255 )'],
       borderColor:['rgba(43, 218, 228 )', 'rgba(5, 40, 115)'],
     },
   ];

   this.mujeresChartPlugins= [{
      beforeDraw(chart) {
        const ctx = chart.ctx;
        const txt = 'Center Text';

        //Get options from the center object in options
        const sidePadding = 60;
        const sidePaddingCalculated = (sidePadding / 100) * (chart.options.aspectRatio * 2)

        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        const centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);
        const centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 2);

        //Get the width of the string and also the width of the element minus 10 to give it 5px side padding
        const stringWidth = ctx.measureText(txt).width;
        const elementWidth = (chart.options.aspectRatio * 2) - sidePaddingCalculated;

        // Find out how much the font can grow in width.
        const widthRatio = elementWidth / stringWidth;
        const newFontSize = Math.floor(30 * widthRatio);
        const elementHeight = (chart.options.aspectRatio * 2);

        // Pick a new font size so it will not be larger than the height of label.
        const fontSizeToUse = Math.min(newFontSize, elementHeight);

        ctx.font = fontSizeToUse + 'px Arial';
        ctx.fillStyle = 'rgba(5, 40, 115)';

        // Draw text in center
        ctx.fillText(porcentaje+'%', centerX, centerY);
      }
    }];
  }

  graficoHombres(numero:any, porcentaje:any){
    let label1 = 'SECCIONES.GENERALES.PERSONAS';
    this.translateSrv.get(label1).subscribe((res: string) => { label1 = res; });
    // Doughnut
    this.detectScreen();
    this.hombresChartOptions= {
     responsive: true,
     tooltips: {enabled: false},
     hover: {mode: null},
     legend: {
       position: 'bottom',
       fullWidth:true,
       labels: {
                fontSize: this.fuenteGraficasSexo,
                fontColor: 'rgb(0, 0, 0)',
                fontStyle: 'bold',
            },
        onClick: function (e) {
        e.stopPropagation();
      },
     },
   };
    this.hombresChartLabels= [(numero+label1)];
    this.hombresChartData= [
      [porcentaje, (100-porcentaje)],
    ];
    this.hombresChartType= 'doughnut';

    this.hombresChartColors = [
     {
       backgroundColor: ['rgba(43, 218, 228 )', 'rgba(255, 255, 255 )'],
       borderColor:['rgba(43, 218, 228 )', 'rgba(5, 40, 115)'],
     },
   ];

   this.hombresChartPlugins= [{
      beforeDraw(chart) {
        const ctx = chart.ctx;
        const txt = 'Center Text';

        //Get options from the center object in options
        const sidePadding = 60;
        const sidePaddingCalculated = (sidePadding / 100) * (chart.options.aspectRatio * 2)

        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        const centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);
        const centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 2);

        //Get the width of the string and also the width of the element minus 10 to give it 5px side padding
        const stringWidth = ctx.measureText(txt).width;
        const elementWidth = (chart.options.aspectRatio * 2) - sidePaddingCalculated;

        // Find out how much the font can grow in width.
        const widthRatio = elementWidth / stringWidth;
        const newFontSize = Math.floor(30 * widthRatio);
        const elementHeight = (chart.options.aspectRatio * 2);

        // Pick a new font size so it will not be larger than the height of label.
        const fontSizeToUse = Math.min(newFontSize, elementHeight);

        ctx.font = fontSizeToUse + 'px Arial';
        ctx.fillStyle = 'rgba(5, 40, 115)';

        // Draw text in center
        ctx.fillText(porcentaje+'%', centerX, centerY);
      }
    }];
  }

  // events
  public chartClicked({ event, active }: { event: MouseEvent, active: {}[] }): void {
    console.log(event, active);
  }

  public chartHovered({ event, active }: { event: MouseEvent, active: {}[] }): void {
    console.log(event, active);
  }

  detectScreen(){
    if(this.ventana_ancho<=780 && this.ventana_ancho>=551){
      this.fuente=17;
      this.fuenteGraficasSexo=14;
    }
        else if(this.ventana_ancho<=550){
          this.fuente=12;
          this.fuenteGraficasSexo=9;
        }
        else{
          this.fuente=23;
          this.fuenteGraficasSexo=20;
        }
      }

}
